import { Component } from '@angular/core';
import { AutoCompleteSearchDropdownOptionsI } from '../autocomplete-field/autocomplete-field.interface';
import { ControlContainer, FormGroupDirective } from '@angular/forms';


@Component({
  selector: 'app-not-in-rto',
  templateUrl: './not-in-rto.component.html',
  styleUrls: ['./not-in-rto.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class NotInRtoComponent {
  controlName = 'not_in_rto';

  autoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI = {
    searchApiUrl: '/services/api/v1/rb_masters/get-rto-by-name',
    dataApiUrl: '/services/api/v1/rb_masters/rtos',
    queryParamKey: 'rto_name',
    dataIdKey: 'rb_id',
    dataNameKey: 'name',
  }
}
